/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Featureddiscounts_Free1Inputs */

const id_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ms_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percuma`)
};

const da_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const de_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const en_us2_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_es2_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const es_mx2_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fil_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

const fr_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const hu_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes`)
};

const nl_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const no_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe`)
};

const pt_br2_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const pt_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ro_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const fi_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const sv_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const vi_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miễn phí`)
};

const tr_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const cs_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdarma`)
};

const bg_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатно`)
};

const ru_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const uk_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовно`)
};

const ar_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني`)
};

const hi_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त`)
};

const th_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const ja_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_cn2_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_hant1_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ko_components_featureddiscounts_free1 = /** @type {(inputs: Components_Featureddiscounts_Free1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Components_Featureddiscounts_Free1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_featureddiscounts_free1 = /** @type {((inputs?: Components_Featureddiscounts_Free1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Featureddiscounts_Free1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_featureddiscounts_free1(inputs)
	if (locale === "ms") return ms_components_featureddiscounts_free1(inputs)
	if (locale === "da") return da_components_featureddiscounts_free1(inputs)
	if (locale === "de") return de_components_featureddiscounts_free1(inputs)
	if (locale === "en-US") return en_us2_components_featureddiscounts_free1(inputs)
	if (locale === "es-ES") return es_es2_components_featureddiscounts_free1(inputs)
	if (locale === "es-MX") return es_mx2_components_featureddiscounts_free1(inputs)
	if (locale === "fil") return fil_components_featureddiscounts_free1(inputs)
	if (locale === "fr") return fr_components_featureddiscounts_free1(inputs)
	if (locale === "it") return it_components_featureddiscounts_free1(inputs)
	if (locale === "hu") return hu_components_featureddiscounts_free1(inputs)
	if (locale === "nl") return nl_components_featureddiscounts_free1(inputs)
	if (locale === "no") return no_components_featureddiscounts_free1(inputs)
	if (locale === "pl") return pl_components_featureddiscounts_free1(inputs)
	if (locale === "pt-BR") return pt_br2_components_featureddiscounts_free1(inputs)
	if (locale === "pt") return pt_components_featureddiscounts_free1(inputs)
	if (locale === "ro") return ro_components_featureddiscounts_free1(inputs)
	if (locale === "fi") return fi_components_featureddiscounts_free1(inputs)
	if (locale === "sv") return sv_components_featureddiscounts_free1(inputs)
	if (locale === "vi") return vi_components_featureddiscounts_free1(inputs)
	if (locale === "tr") return tr_components_featureddiscounts_free1(inputs)
	if (locale === "cs") return cs_components_featureddiscounts_free1(inputs)
	if (locale === "bg") return bg_components_featureddiscounts_free1(inputs)
	if (locale === "ru") return ru_components_featureddiscounts_free1(inputs)
	if (locale === "uk") return uk_components_featureddiscounts_free1(inputs)
	if (locale === "ar") return ar_components_featureddiscounts_free1(inputs)
	if (locale === "hi") return hi_components_featureddiscounts_free1(inputs)
	if (locale === "th") return th_components_featureddiscounts_free1(inputs)
	if (locale === "ja") return ja_components_featureddiscounts_free1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_featureddiscounts_free1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_featureddiscounts_free1(inputs)
	return ko_components_featureddiscounts_free1(inputs)
});
export { components_featureddiscounts_free1 as "components.featuredDiscounts.free" }